<script>
import DataTable from './DataTable.vue';
import ListActionDropdown from './ListActions/ListActionDropdown.vue';
import SeasonSelector from './Selectors/SeasonSelector.vue';
import StateSelector from './Selectors/StateSelector.vue';
import SavedViewsShortcutsBar from '../../modules/search/components/SavedViewsShortcutsBar';

/**
 * The base ResourceList component.
 */
export default {
  components: {
    DataTable,
    ListActionDropdown,
    SeasonSelector,
    StateSelector,
    SavedViewsShortcutsBar
  },
  props: {
    ids: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selected: [],
      reveal: null
    };
  },
  methods: {
    onReveal(action) {
      this.reveal = this.reveal !== action ? action : null;
    }
  }
};
</script>
